/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";

import TbodyComponent from "./sub-module/TbodyComponent";
import "./index.scss";
import useApprovalHours from "../../store/useApprovalHours";
import Spinner from "../../../../components/Spinner";
import ButtonNavigatorComponent from "../../../../components/ButtonNavigator";
import { IconSwitch } from "../../../../icons";
import IconButton from "../../../../components/IconButton";

interface TableProps {
  checkboxSelection: boolean;
  details?: boolean;
}

export default function TableComponent({ details, checkboxSelection }: TableProps) {
  const { listRender, columns, page, selectSize, setSelectSize, setPage, needSpinner, handleOrderList, state } = useApprovalHours();

  const [checked, setChecked] = useState(false);

  function setSelectSizePage(value: string | number): void {
    setPage(0);
    setSelectSize(value);
  }

  return (
    <div className="tableContainer table-container-full">
      <Spinner classNameFather="spinnerTable" status={needSpinner}>
        <table className="table-container-header-body">
          <thead>
            <tr>
              {checkboxSelection && (
                <th className="checkboxRow">
                  <input className="checkboxInput" checked={checked} type="checkbox" onChange={() => setChecked((checked) => !checked)} />
                </th>
              )}
              {columns?.map((col: any, index: number) => {
                if (col.field === "payment_amount" && state) return;
                return (
                  <th
                    key={index}
                    style={{
                      maxWidth: col.width || `${100 / columns?.length}%`,
                    }}
                    className={`${col.field === "projectName" && "invisible-850px"}`}
                  >
                    <div className="wrapperTheader">
                      <span>{col.headerName}</span>
                      <IconButton icon={IconSwitch} onClick={() => handleOrderList(col.field)} />
                    </div>
                  </th>
                );
              })}
              {details && <th className="col-function">Detalhes</th>}
            </tr>
          </thead>
          {listRender?.length ? (
            <TbodyComponent details={details} checkedAll={checked} checkboxSelection={checkboxSelection} />
          ) : (
            <div className="nothing-list">
              <h1>Não há registros para a busca realizada.</h1>
            </div>
          )}
        </table>
        {listRender?.length ? (
          <ButtonNavigatorComponent
            className="ButtonNavigatorCollaborator"
            page={page}
            setPage={setPage}
            selectSize={selectSize}
            setSelectSize={setSelectSizePage}
            list={listRender}
            setPageFirstRender={false}
          />
        ) : (
          ""
        )}
      </Spinner>
    </div>
  );
}
